export default {
    state: {
        menu:[],//全部菜单
        currentMenu:{label:"menu.profitAddress"},//选择的菜单
        chooseTime:{
            start:"",
            end:""
        }
    },
    mutations: {
        selectMenu(state,val){
            state.currentMenu =val
        },
        handelTime(state,val){
            state.chooseTime.start =val[0]
            state.chooseTime.end=val[1]
           
        }
    },
    actions: {
  
    },
  
}